import AgendarAdminPagina from './AgendarAdminPagina';

export default AgendarAdminPagina;